import React, { useState, useEffect, useContext } from 'react';
import './Dashboard.css';
import Url from '../Url';
import { LoginContext } from '../Login/LoginContext';

import {
    PieChart,
    Pie,
    Cell,
    Tooltip as RechartsTooltip,
} from 'recharts';

export default function Dashboard() {
    const { loginResult } = useContext(LoginContext);
    const [dashdata, setDashdata] = useState([]);
    const [loading, setLoading] = useState(false);
    const user_id = loginResult?.user_id;

    useEffect(() => {
        if (!user_id) return;

        setLoading(true);
        fetch(
            `${Url.Url}/get_report?data=` +
            encodeURIComponent(
                JSON.stringify({
                    report_id: 9,
                    user_id: user_id,
                })
            )
        )
            .then((res) => res.json())
            .then((data) => {
                if (Array.isArray(data) && Array.isArray(data[0])) {
                    setDashdata(data[0]);
                } else {
                    setDashdata([]);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error('API Error:', err);
                setLoading(false);
            });
    }, [user_id]);

    const totalLeads = dashdata.length;

    const leadsCountByStatus = dashdata.reduce((acc, lead) => {
        if (lead.status) {
            const statusKey = lead.status.trim();
            acc[statusKey] = (acc[statusKey] || 0) + 1;
        }
        return acc;
    }, {});

    const pieData = Object.entries(leadsCountByStatus).map(([name, value]) => ({
        name,
        value,
    }));

    const COLORS = [
        '#0d47a1', '#c62828', '#2e7d32', '#6a1b9a', '#ff6f00',
        '#00838f', '#4e342e', '#37474f', '#3e2723', '#1b5e20',
        '#1565c0', '#ad1457', '#4527a0', '#00695c',
    ];

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                <div
                    style={{
                        background: '#fff',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        fontSize: '13px',
                        color: '#333',
                        border: '1px solid #ccc',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                        pointerEvents: 'none',
                    }}
                >
                    <strong>{data.name}</strong>
                    <br />
                    Leads: {data.value}
                </div>
            );
        }
        return null;
    };

    return (
        <div>
            {loading ? (
                <p style={{ fontSize: '18px', textAlign: 'center', marginTop: 50 }}>Loading data...</p>
            ) : (
                <>
                    <div className="dashboard-stats-container">
                        <div className="dashboard-stat-box">
                            <div className="dashboard-stat-label">Total Leads</div>
                            <div className="dashboard-stat-value">{totalLeads}</div>
                        </div>

                        {/* Render all statuses with counts only, no percentages */}
                        {Object.entries(leadsCountByStatus).map(([status, count]) => (
                            <div key={status} className="dashboard-stat-box">
                                <div className="dashboard-stat-label">{status}</div>
                                <div className="dashboard-stat-value">{count}</div>
                            </div>
                        ))}
                    </div>

                    <div className="dashboard-bottom-section">
                        <div className="dashboard-pie-chart-wrapper">
                            <h3 className="dashboard-pie-title">Leads Status Distribution</h3>

                            {pieData.length > 0 ? (
                                <PieChart width={750} height={300}>
                                    <Pie
                                        data={pieData}
                                        cx="80%"
                                        cy="50%"
                                        labelLine={true}
                                        dataKey="value"
                                        label={({ percent }) => `${(percent * 100).toFixed(1)}%`}
                                    >
                                        {pieData.map((entry, index) => (
                                            <Cell
                                                key={`cell-${index}`}
                                                fill={COLORS[index % COLORS.length]}
                                            />
                                        ))}
                                    </Pie>
                                    <RechartsTooltip content={<CustomTooltip />} />
                                </PieChart>
                            ) : (
                                <p>No lead data available for chart.</p>
                            )}

                            <div
                                className="manual-legend"
                                style={{ display: 'flex', flexWrap: 'wrap', marginTop: 10 }}
                            >
                                {pieData.map((entry, index) => (
                                    <div
                                        key={index}
                                        className="legend-item"
                                        style={{ marginRight: 15, display: 'flex', alignItems: 'center' }}
                                    >
                                        <span
                                            className="legend-color-box"
                                            style={{
                                                backgroundColor: COLORS[index % COLORS.length],
                                                width: 16,
                                                height: 16,
                                                display: 'inline-block',
                                                marginRight: 6,
                                                borderRadius: 3,
                                            }}
                                        ></span>
                                        {entry.name}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
